import React, { useState } from "react";
import { comboBoxStyles } from "../../stylesGenerales/combobox";

const DocumentosTable = ({
    documentosPaginados,
    empleados,
    tiposDocumento,
    downloadFile,
    setDocumentoAEliminar,
    setMostrarModalEliminar,
    paginaActual,
    setPaginaActual,
    totalPaginas,
    puedeEliminar
}) => {
    const [openComboId, setOpenComboId] = useState(null);
    const menuRef = React.useRef(null);
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (openComboId !== null && menuRef.current && !menuRef.current.contains(event.target)) {
                setOpenComboId(null);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openComboId]);

    const thStyle = {
        borderBottom: "2px solid #eee",
        padding: "10px",
        textAlign: "left"
    };
    const tdStyle = { padding: "10px", borderBottom: "1px solid #f0f0f0" };

    const formatDate = dateStr => {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    // Mostrar tipo especial para terminación laboral
    const getTipoDocumento = d => {
        if (!tiposDocumento || tiposDocumento.length === 0) return "-";

        const tipoDoc = tiposDocumento.find(
            t => Number(t.idtipodocumento) === Number(d.idtipodocumento)
        );

        return tipoDoc?.nombretipo ?? "-";
    };

    const getPagination = () => {
        const pages = [];

        for (let i = 1; i <= totalPaginas; i++) {
            if (
                i === 1 ||
                i === totalPaginas ||
                (i >= paginaActual - 1 && i <= paginaActual + 1)
            ) {
                pages.push(i);
            }
        }

        const result = [];
        let prev = null;

        pages.forEach(page => {
            if (prev && page - prev > 1) {
                result.push("...");
            }
            result.push(page);
            prev = page;
        });

        return result;
    };
    return (
        <div
            style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "30px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.08)"
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    borderSpacing: "0 8px"
                }}
            >
                <thead>
                    <tr>
                        <th style={thStyle}>Nombre</th>
                        <th style={thStyle}>Fecha</th>
                        <th style={thStyle}>Trabajador</th>
                        <th style={thStyle}>Tipo</th>
                        <th style={{ ...thStyle, textAlign: "center" }}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {documentosPaginados.length > 0 ? (
                        documentosPaginados.map(d => (
                            <tr key={d.iddocumento}>
                                <td style={tdStyle}>
                                    {d.archivo_url ? d.nombrearchivo : `${d.nombrearchivo} (sin archivo)`}
                                </td>
                                <td style={tdStyle}>{formatDate(d.fechasubida)}</td>
                                <td style={tdStyle}>
                                    {empleados.find(e => e.idempleado === d.idempleado)
                                        ? `${empleados.find(e => e.idempleado === d.idempleado).nombre} ${empleados.find(e => e.idempleado === d.idempleado).apellido}`
                                        : "-"}
                                </td>
                                <td style={tdStyle}>{getTipoDocumento(d)}</td>
                                <td style={{ ...tdStyle, textAlign: "center" }}>
                                    {d.estado === false ? (
                                        <span style={{ color: "#d9534f", fontWeight: "bold" }}>Sin archivo</span>
                                    ) : (
                                        d.archivo_url && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    position: "relative"
                                                }}
                                            >
                                                <div style={comboBoxStyles.container}>
                                                    <button
                                                        style={comboBoxStyles.button.base}
                                                        onClick={() =>
                                                            setOpenComboId(
                                                                openComboId === d.iddocumento ? null : d.iddocumento
                                                            )
                                                        }
                                                    >
                                                        Opciones ▾
                                                    </button>
                                                    {openComboId === d.iddocumento && (
                                                        <div ref={menuRef} style={comboBoxStyles.menu.container}>
                                                            <div
                                                                style={comboBoxStyles.menu.item.activar.base}
                                                                onClick={() => {
                                                                    downloadFile(
                                                                        d.archivo_url,
                                                                        d.nombrearchivo,
                                                                        d.mimearchivo
                                                                    );
                                                                    setOpenComboId(null);
                                                                }}
                                                            >
                                                                Descargar
                                                            </div>
                                                            {puedeEliminar && (
                                                                <div
                                                                    style={comboBoxStyles.menu.item.desactivar.base}
                                                                    onClick={() => {
                                                                        setDocumentoAEliminar(d.iddocumento);
                                                                        setMostrarModalEliminar(true);
                                                                        setOpenComboId(null);
                                                                    }}
                                                                >
                                                                    Eliminar
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    )}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                                No hay documentos registrados
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            {totalPaginas > 1 && (
                <div
                    style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                        flexWrap: "wrap"
                    }}
                >
                    <button
                        disabled={paginaActual === 1}
                        onClick={() => setPaginaActual(paginaActual - 1)}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "1px solid #219ebc",
                            cursor: paginaActual === 1 ? "not-allowed" : "pointer"
                        }}
                    >
                        ←
                    </button>

                    {getPagination().map((item, index) =>
                        item === "..." ? (
                            <span
                                key={`dots-${index}`}
                                style={{
                                    padding: "6px 10px",
                                    color: "#666"
                                }}
                            >
                                ...
                            </span>
                        ) : (
                            <button
                                key={`page-${item}`}
                                onClick={() => setPaginaActual(item)}
                                style={{
                                    padding: "6px 12px",
                                    border: "1px solid #219ebc",
                                    background:
                                        paginaActual === item
                                            ? "#219ebc"
                                            : "#fff",
                                    color:
                                        paginaActual === item
                                            ? "#fff"
                                            : "#219ebc",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontWeight:
                                        paginaActual === item
                                            ? "bold"
                                            : "normal"
                                }}
                            >
                                {item}
                            </button>
                        )
                    )}

                    <button
                        disabled={paginaActual === totalPaginas}
                        onClick={() => setPaginaActual(paginaActual + 1)}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "1px solid #219ebc",
                            cursor:
                                paginaActual === totalPaginas
                                    ? "not-allowed"
                                    : "pointer"
                        }}
                    >
                        →
                    </button>
                </div>
            )}
        </div>
    );
};

export default DocumentosTable;
